"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var ui_1 = require("@vidazoo/ui");
var theme = require("../reportingList/theme.scss");
var components_1 = require("../../../reporting/components");
var lib_1 = require("../../../../lib");
exports.default = React.memo(function (_a) {
    var group = _a.group, quickFilter = _a.quickFilter, setFreezeColumn = _a.setFreezeColumn, freezeColumnIndex = _a.freezeColumnIndex, dataGridColumnIndex = _a.dataGridColumnIndex, onSort = _a.onSort, onSearch = _a.onSearch, sortDirection = _a.sortDirection, enableQuickFilter = _a.enableQuickFilter;
    var onQuickFilter = function () {
        quickFilter(group);
    };
    var openLink = function () {
        window.open(group.link, "_blank");
    };
    var onFreezeColumn = function () {
        setFreezeColumn({ target: { checked: freezeColumnIndex !== dataGridColumnIndex, value: dataGridColumnIndex } });
    };
    var onOrder = function () {
        onSort(group.name);
    };
    var onSearchItem = function () {
        onSearch(group.name, window.getSelection().toString() || group.value);
    };
    var onCopy = function () {
        lib_1.MemoryClipboard.copy(window.getSelection().toString() || group.value);
    };
    var value = group.link
        ? React.createElement("a", { href: group.link, target: "_blank" }, group.value)
        : group.value;
    var valueRender = (enableQuickFilter && onQuickFilter)
        ? React.createElement(components_1.QuickReportAction, { iconName: "icon-filter", tooltipTitle: "Add Filter", item: group, onClick: onQuickFilter }, value)
        : value;
    var contextMenuItems = [
        {
            label: freezeColumnIndex === dataGridColumnIndex ? "Unfreeze Column" : "Freeze Column",
            onClick: onFreezeColumn
        },
        { label: "Order " + sortDirection, onClick: onOrder },
        { label: "Search", onClick: onSearchItem },
        { label: "Copy", onClick: onCopy }
    ];
    if (enableQuickFilter && onQuickFilter) {
        contextMenuItems.push({ label: "Apply Filter", onClick: onQuickFilter });
    }
    if (group.link) {
        contextMenuItems.push({ label: "Open Link in New Tab", onClick: openLink });
    }
    return (React.createElement(ui_1.ContextMenu, { items: contextMenuItems },
        React.createElement("div", { className: theme.cell }, valueRender)));
});
